var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.store)?_c('mallListDistributor',{attrs:{"rel-store":_vm.store,"template-type":"distributor"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }